// extracted by mini-css-extract-plugin
module.exports = {"content":"NotFound_content__2r5M2","button":"NotFound_button__37yNX"};